<template>
  <div class="my-2">
    <div v-for="realty in realties" :key="realty.id" class="realties">
      <div class="realty-item">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-chip v-on="on" v-bind="attrs" small>
              {{ realty.code }}
            </v-chip>
          </template>
          <span>
            {{ realty.address }}
          </span>
        </v-tooltip>
        <p v-if="showExtraContent" class="caption mt-1 mb-0">
          {{ realty.address }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppointmentListRealties',

  props: {
    showExtraContent: {
      type: Boolean,
      default: false
    },

    realties: {
      type: Array | Object | String,
      default: () => []
    }
  }
}
</script>

<style scoped>
.realties {
  display: block;
}

.realty-item:not(:last-child) {
  padding-bottom: 5px;
  margin-bottom: 5px;
  border-bottom: 1px dotted #999;
}
</style>
